import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

export const Route = createFileRoute('/_auth/reset-password')({
  validateSearch: z.object({
    token: z.string(),
  }),
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/reinitialiser-mot-de-passe', search, replace: true })
  },
})
